import { OpenDialog } from './../../../utils/openDialog';
import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../model/User';
import { UserProfileService, PagedResponse } from '../service/user-profile.service';
import { AppModalAdministratorUserComponent } from '../modal/app-modal-administrator-user.component';
import { Profile } from '../model/Profile';
import { properties } from '../../../../environments/properties';
import { DialogCustomComponent } from '../../../../app/app-datahealth/app-dialog-custom/app-dialog-custom.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpResponse } from '@angular/common/http';

@Component({
    selector: 'app-app-administrator',
    templateUrl: './app-administrator.component.html',
    styleUrls: ['./app-administrator.component.css'],
    standalone: false
})
export class AppAdministratorComponent implements OnInit {

  public displayedColumns: string[] = [
    'identification',
    'name',
    'email',
    'perfil',
    'status',
    'edit'
  ];

  public users : User[] = []; 
  public totalUsers: number = 0;
  public pageIndex: number = 0;
  public pageSize: number = 10;


  public dataSourceUserProfile: MatTableDataSource<User> = new MatTableDataSource<User>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  private readonly ATIVO:   string  = "A";
  private readonly INATIVO: string  = "I";

  constructor(private dialog: MatDialog,  private userProfileService:UserProfileService, private openDialogUtils: OpenDialog) { }

  ngOnInit() {
    this.loadUsers(this.pageIndex, this.pageSize);
  }

  private loadUsers(page: number, size: number): void {
    this.userProfileService.getListUsersProfile(page, size).subscribe(
     (response: HttpResponse<User[] | PagedResponse<User>>) => {
      const dataSource = response.body;
      const users = Array.isArray(dataSource) ? dataSource : (dataSource?.content || []);
      this.users = users;

      // Backends may return pagination in body OR headers (e.g. X-Total-Count).
      const totalFromBody = Array.isArray(dataSource)
        ? undefined
        : dataSource?.totalElements;
      const totalHeaderRaw =
        response.headers.get('X-Total-Count') ||
        response.headers.get('x-total-count') ||
        response.headers.get('total-elements') ||
        response.headers.get('Total-Elements');
      const totalFromHeader = totalHeaderRaw !== null ? Number(totalHeaderRaw) : Number.NaN;
      const totalFromBodyNumber = Number(totalFromBody);

      if (Number.isFinite(totalFromBodyNumber)) {
        this.totalUsers = totalFromBodyNumber;
      } else if (Number.isFinite(totalFromHeader)) {
        this.totalUsers = totalFromHeader;
      } else {
        // Fallback for APIs that return only the current page list:
        // if the page is full, keep "next" enabled by projecting one extra item.
        const baseCount = (page * size) + users.length;
        this.totalUsers = users.length === size ? baseCount + 1 : baseCount;
      }

      this.pageIndex = Array.isArray(dataSource)
        ? page
        : (dataSource?.number ?? page);
      this.pageSize = Array.isArray(dataSource)
        ? size
        : (dataSource?.size ?? size);

      this.dataSourceUserProfile = new MatTableDataSource(users);
    }, (_err: unknown) => {
      this.openDialog(
        properties.MODAL_ERROR_TITLE,
        properties.MODAL_CONTENT_LOAD_USER_ERROR);
    });
  }

  public onPageChange(event: PageEvent): void {
    this.loadUsers(event.pageIndex, event.pageSize);
  }

  public modalConfig(user: User):MatDialogConfig{

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
    "usuario":  user
    }
    dialogConfig.width = '50%';
    dialogConfig.height = '65%';

    return dialogConfig;

  }

  public openCreateOrUpdatdUserForApplication(dialogConfig: MatDialogConfig): void{

    this.dialog
    .open(AppModalAdministratorUserComponent, dialogConfig)
    .afterClosed().subscribe(() => {
      this.loadUsers(this.pageIndex, this.pageSize);
    });


  }

  public createUser(){
    let user: User = new User();
    user.status = this.ATIVO;
    user.profile = new Profile();
    let dialogConfig = this.modalConfig(user);
    this.openCreateOrUpdatdUserForApplication(dialogConfig);
  }

  public userExists (userEmail: string){
    if(userEmail in this.users){
      return true;
    }

    return false
  }

  public editUser(user: User){

    let dialogConfig = this.modalConfig(user);
    this.openCreateOrUpdatdUserForApplication(dialogConfig);
  }

  public changed(user: User){

    user.status = user.status === this.ATIVO ? this.INATIVO : this.ATIVO;

    this.userProfileService.saveUserProfile(user).subscribe(() => {
      this.updateTableDataSource(user);
      this.openDialog(
        properties.MODAL_TITLE_SUCESS,
        properties.MODAL_CONTENT_USER_SAVE_SUCESS);
    }, (_err: unknown) => {
      this.openDialog(
        properties.MODAL_ERROR_TITLE,
        properties.MODAL_CONTENT_USER_SAVE_ERROR);
        user.status = user.status === this.ATIVO ? this.INATIVO : this.ATIVO;
        this.updateTableDataSource(user);
    });

  }

  public updateTableDataSource(user: User):void{

    this.dataSourceUserProfile.data.forEach((value: User) => {
      if(value.id === user.id){
        value.status = user.status;
      }
    });

  }

  private openDialog(admTitleParam: string, admmessageParam: string): void {
    this.openDialogUtils.openDialog(admTitleParam,admmessageParam)
  }

}
